import { z } from 'zod'

export const PiloteLocationOrientationZod = z.enum(['NORTH', 'SOUTH', 'EAST', 'WEST'])

export const PiloteLocationRecordZod = z.object({
  id: z.number(),
  version: z.number(),
  central_id: z.number(),
  region_id: z.number(),
  name: z.string(),
  civic_number: z.string().nullable(),
  street: z.string().nullable(),
  latitude: z.number(),
  longitude: z.number(),
  orientation: PiloteLocationOrientationZod.nullable(),
  active: z.boolean(),
  municipalities: z.array(z.string()).nullish().default([]),
})
